import { Redirect, truthy } from "@quortex/front-common"
import type { DefaultGenerics, Route } from "@tanstack/react-location"
import { lazy } from "react"
import PendingOrganization from "./landings/PendingOrganization"
import { settingsRoutes } from "./settings/routes"

// Misc
const Root = lazy(() => import("./Root"))
const HomePage = lazy(() => import("./homePage"))
const Organization = lazy(() => import("./OrganizationRoute"))

// Landings
const InviteRequest = lazy(() => import("./landings/InviteRequest"))
const Invitation = lazy(() => import("./landings/Invitation"))
const NewOrganization = lazy(() => import("./landings/NewOrganization"))
const NotFound = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.NotFound }))
)

export const portalTree: Route<DefaultGenerics> = {
  path: "/",
  element: <Root />,
  children: [
    // Organization-less landing pages
    {
      path: "invitation/:invitationCode",
      element: <Invitation />
    },

    // Old portal routes
    // TODO: move all of them to new portal routes
    {
      path: "organizations/new",
      element: <NewOrganization />
    },
    {
      path: "organizations/:orgUuid",
      element: <Organization />,
      children: [
        {
          path: "invite_request/:userUuid",
          element: <InviteRequest />
        },
        {
          path: "pending",
          element: <PendingOrganization />
        },
        {
          path: "play",
          element: <Redirect external replace to={import.meta.env.REACT_APP_PLAY_URL} withOrg />
        },
        {
          path: "link",
          element: <Redirect external replace to={import.meta.env.REACT_APP_LINK_URL} withOrg />
        },
        {
          path: "switch",
          element: <Redirect external replace to={import.meta.env.REACT_APP_SWITCH_URL} withOrg />
        },
        {
          path: "ingest",
          element: <Redirect external replace to={import.meta.env.REACT_APP_INGEST_URL} withOrg />
        },
        {
          path: "powervu",
          element: <Redirect external replace to={import.meta.env.REACT_APP_POWERVU_URL} withOrg />
        },
        {
          path: "tune",
          element: <Redirect external replace to={import.meta.env.REACT_APP_TUNE_URL} withOrg />
        },
        settingsRoutes,

        // Home page
        { path: "home", element: <HomePage /> },

        // Fallback
        { element: <NotFound /> }
      ]
    },

    { element: <NotFound /> }
  ].filter(truthy)
}
